/**
 * Chat Storage Service
 * 
 * This service provides functionality to save and load chat messages from localStorage
 * It handles serialization, deserialization, and manages the localStorage key
 */

const STORAGE_KEY = 'chat_message_history';
const MAX_STORED_MESSAGES = 50; // Limit to prevent localStorage from getting too large

/**
 * Save messages to localStorage
 * 
 * @param {Array} messages - Array of message objects to save
 * @returns {boolean} - Success status of the save operation
 */
export const saveMessages = (messages) => {
  try {
    // Limit the number of messages we store to prevent localStorage from getting too large
    const messagesToStore = messages.slice(-MAX_STORED_MESSAGES);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(messagesToStore));
    return true;
  } catch (error) {
    console.error('Error saving chat messages to localStorage:', error);
    return false;
  }
};

/**
 * Load messages from localStorage
 * 
 * @returns {Array} - Array of message objects, or empty array if none found
 */
export const loadMessages = () => {
  try {
    const storedMessages = localStorage.getItem(STORAGE_KEY);
    if (!storedMessages) {
      return [];
    }
    return JSON.parse(storedMessages);
  } catch (error) {
    console.error('Error loading chat messages from localStorage:', error);
    return [];
  }
};

/**
 * Clear all stored messages from localStorage
 * 
 * @returns {boolean} - Success status of the clear operation
 */
export const clearMessages = () => {
  try {
    localStorage.removeItem(STORAGE_KEY);
    return true;
  } catch (error) {
    console.error('Error clearing chat messages from localStorage:', error);
    return false;
  }
};

export default {
  saveMessages,
  loadMessages,
  clearMessages
};
